<template>
  <div class="login_body">

    <section>

      <div class="login_middle_form">

        <router-link to="/" class="login_middle_logo">
          <img src="../../assets/logo_white.png" />
        </router-link>

        <div class="tips">蛋白靶点受体的小分子配体或小分子配体的蛋白靶点组</div>

        <form :model="loginForm" :rules="rules">
          <ul>
            <li>
              <input type="password" placeholder="输入密码" name="oldpassword" v-model="loginForm.oldpassword">
            </li>
            <li>
              <input type="password" placeholder="输入新密码，密码最少6位，包括至少1个大写字母，1个小写字母，1个数字，1个特殊字符" name="newpassword" v-model="loginForm.newpassword">
            </li>
            <li>
              <input type="password" placeholder="再次输入新密码，密码最少6位，包括至少1个大写字母，1个小写字母，1个数字，1个特殊字符" name="newpasswordvalidate"
                v-model="loginForm.newpasswordvalidate">
            </li>
          </ul>
          <a href="javascript:void(0)" class="login_btn" @click="confirm" style="margin-top:10px;">修改</a>
        </form>
      </div>

    </section>
    <LoginFooter></LoginFooter>
  </div>
</template>

<script>
import LoginFooter from '../footer/login_footer.vue';
import api from './../../axios/api.js';
import md5 from './../../assets/js/md5.min.js'


export default {
  components: {
    LoginFooter
  },
  data() {
    return {
      loginForm: {
        name: '',
        password: '',
      },
      registerForm: {
        name: "",
        tel: "",
        idcard: ""
      },
      popBgShow: false,
      popShow: false,
      rules: {
        oldpassword: [{ required: true, message: "请输入密码", trigger: "blur" }],
        newpassword: [{ required: true, message: "请输入新密码", trigger: "blur" }],
        newpasswordvalidate: [{ required: true, message: "请再次输入新密码", trigger: "blur" }],
      }
    }
  },
  mounted() {
  },
  methods: {
    applyOpen() {
      this.popBgShow = true;
      this.popShow = true;
    },
    applyClose() {
      this.popBgShow = false;
      this.popShow = false;
    },
    confirm() {
      let that = this;
      const oldpassword = md5.md5(this.loginForm.oldpassword, 32);
      const newpassword = md5.md5(this.loginForm.newpassword, 32);
      const newpasswordvalidate = md5.md5(this.loginForm.newpasswordvalidate, 32);
      // console.log(md5.md5(oldpassword));
      if (!oldpassword) {
        alert("账号不能为空！");
      } else if (!newpassword) {
        alert("新密码不能为空！");
      } else if (!newpasswordvalidate) {
        alert("确认新密码不能为空！");
      } else {
        ////密码正则，最少6位，包括至少1个大写字母，1个小写字母，1个数字，1个特殊字符
        var pwdPattern = /^.*(?=.{6,})(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*? ]).*$/;
        if (newpassword != newpassword) {
          alert("两次输入的密码需要一致");
        }
        if (!pwdPattern.test(newpassword)) {
          alert("您的密码格式有误");
        }
        let urllist = '/action/users/modifypassword';
        let username = localStorage.getItem("username");
        api.getTableData(urllist, JSON.stringify({ "username": username, oldpassword: oldpassword, newpassword: newpassword, newpasswordvalidate: newpasswordvalidate })).then(res => {
          if (res.result == 1) {
            window["authtoken"] = "";
            localStorage.removeItem("authtoken");
            localStorage.removeItem("isLogined");
            localStorage.removeItem("needLogin");
            localStorage.removeItem("username");
            location.href = "/login";
          }
        });
        //this.$router.replace('/');
      }
    },
    registerconfirm() {
      let that = this;
      const regName = this.registerForm.name;
      const tel = this.registerForm.tel;
      const idcard = 2;
      if (!regName) {
        this.showMessage("名称不能为空！");
      } else if (!tel) {
        this.showMessage("联系方式不能为空！");
      } else if (!idcard) {
        this.showMessage("身份不能为空！");
      } else {
        let urllist = '/action/users/regester';
        let param = {
          username: regName,
          phone: tel,
          type: idcard,
          nickname: regName,
          sex: 3,
          realname: regName,
          birthday: null
        };
        api.getTableData(urllist, JSON.stringify(param)).then(res => {
          if (res.result == 1) {
            if (res.data) {
              location.href = "/";
            } else {
              that.showMessage("用户名已存在！");
            }
          }
        });
      }
    },
    showMessage(val) {
      toastr.error(val, "错误", {
        closeButton: true,
        progressBar: true,
        newestOnTop: true
      });
    }
  }
}
</script>


<style scoped>
section {
  padding-top: 0;
}

.form-select {
  width: 100%;
  border: 1px solid #d6d6d6;
  border-radius: 5px;
  padding: 0 10px;
  font-size: 14px;
  color: #333;
  height: 45px;
  line-height: 45px;
  -webkit-transition: all 0.2s linear 0s;
  transition: all 0.2s linear 0s;
}
</style>



// WEBPACK FOOTER //
// src/views/login/modify.vue